import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewContainerRef } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { PromptOption } from 'src/app/pages/prompt-register/models/prompt-option.interface';
import { LCS_SINGLE_SELECT_OPTIONS, LcsSingleSelectBase } from '../../single-select/single-select-base';
import { promptOptionSelectors } from '../state/prompt-option.reducer';

@Component({
    providers: [
        {
            provide: LCS_SINGLE_SELECT_OPTIONS,
            useExisting: PromptSelectComponent,
        },
    ],
    selector: 'ndt-prompt-select',
    templateUrl: './prompt-select.component.html',
    standalone: false
})
export class PromptSelectComponent extends LcsSingleSelectBase<PromptOption> implements OnInit {
   @Input() promptIdsToInclude: number[];

   prompts: Observable<PromptOption[] | null>;

   constructor(
      protected elementRef: ElementRef,
      protected changeDetectorRef: ChangeDetectorRef,
      protected viewContainerRef: ViewContainerRef,
      private store: Store
   ) {
      super(elementRef, changeDetectorRef, viewContainerRef);
   }

   ngOnInit(): void {
      this.prompts = this.store.pipe(select(promptOptionSelectors.selectFilteredItems), this.itemsLoaded());
   }

   displayWith(item: PromptOption | null): string | null {
      return item?.name ? item.name : null;
   }

   trackBy(item: PromptOption | null) {
      return item ? item.promptId : null;
   }
}
